/* eslint-disable object-shorthand */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// api
import { signinWithPW } from '../../services/apis/auth';
import {
	getUserInfoFromAlcohol,
	postUserLoginHistoryToAlcohol,
} from '../../services/apis/alcohol/user';
import {
	getUserInfoFromHearro,
	postUserLoginHistoryToHearro,
} from '../../services/apis/hearro/user';
import { getUserInfoFromMomthera } from '../../services/apis/momthera/user';
import getSystemMessageFromHearro from '../../services/apis/hearro/systemMessage';
import getSystemMessageFromAlcohol from '../../services/apis/alcohol/systemMessage';

// components
import CommonModal from '../../components/modal/CommonModal';
import { useSystemMessage } from '../../contexts/SystemMessageContext';

// utils
import { hasForbiddenChars, FORBIDDEN_CHARS_MSG } from '../../utils/sanitize';

function SignInPage({ type }) {
	const [id, setId] = useState(localStorage.getItem('saveId') || '');
	const [pw, setPw] = useState('');

	const [saveId, setSaveId] = useState(!!localStorage.getItem('saveId'));

	const [showFailModal, setShowFailModal] = useState(false);

	const [showEmptyModal, setShowEmptyModal] = useState(false);

	const [showTooManyAttemptsModal, setShowTooManyAttemptsModal] = useState(false);
	const [remainingMinutes, setRemainingMinutes] = useState(5);

	const [showSessionExpiredModal, setShowSessionExpiredModal] = useState(false);

	const navigate = useNavigate();
	const { showMessage } = useSystemMessage();
	const defaultMessage = '인가되지 않은 시스템 사용은 금지되며 민·형사상의 처벌 대상입니다.';

	const triggerSystemMessage = async () => {
		let msg = defaultMessage;
		try {
			const fetchMessage = { dtx001: getSystemMessageFromAlcohol, dtx002: getSystemMessageFromHearro }[type];
			const res = fetchMessage ? await fetchMessage() : null;
			if (res?.status >= 200 && res.status < 300 && typeof res.data === 'string' && res.data.trim()) {
				msg = res.data;
			}
		} catch (e) {
			// ignore and use defaultMessage
		}
		showMessage(msg, 2000);
	};

	// 로그인 시도
	async function trySignIn() {
		if (!id || !pw) {
			setShowEmptyModal(true);
			return;
		}
		if (hasForbiddenChars(id) || hasForbiddenChars(pw)) {
			return;
		}

		try {
			const request = {
				username: id,
				password: pw,
			};

			const res = await signinWithPW(request);

			if (parseInt(res.status / 200, 10) === 1) {
				localStorage.setItem(`${type}token`, JSON.stringify(res.data));
				let resInfo;
				if (type === 'dtx001') {
					resInfo = await getUserInfoFromAlcohol();
				} else if (type === 'dtx002') {
					resInfo = await getUserInfoFromHearro();
				} else if (type === 'dtx006') {
					resInfo = await getUserInfoFromMomthera();
				}

				if (parseInt(resInfo.status / 200, 10) === 1) {
					// 로그인 성공 시 ID를 localStorage에 자동 저장
					localStorage.setItem('saveId', id);

					// 임시 비밀번호로 로그인한 경우 -> 비밀번호 변경 페이지로 이동
					if (res.data.alertCode === 'Initial-Password-Change-Required') {
						if (type !== 'dtx006') alert('초기 비밀번호를 변경해 주십시오.');
						sessionStorage.setItem('loginID', id);
						navigate(`/change-pw/${type}/initial`);
						return;
					}

					// 정상 로그인
					if (type === 'dtx001') {
						await postUserLoginHistoryToAlcohol();
						triggerSystemMessage(type);
						navigate('/dtx001/dashboard');
					} else if (type === 'dtx002') {
						await postUserLoginHistoryToHearro();
						triggerSystemMessage(type);
						navigate('/dtx002/patient-manage/list');
					} else if (type === 'dtx006') {
						// triggerSystemMessage(type);
						navigate('/dtx006/dashboard');
					}
				} else {
					localStorage.removeItem(`${type}token`);
					setShowFailModal(true);
				}
				// 비밀번호 변경 6개월이 경과된 경우 -> 비밀번호 변경 페이지로 이동
			} else if (
				res.response &&
				res.response.status === 401 &&
				res.response.data.code === 'Password-Replacement-Required'
			) {
				if (type !== 'dtx006') alert(res.response.data.message);
				sessionStorage.setItem('loginID', id);
				navigate(`/change-pw/${type}/month6`);
				// 로그인 5번 연속 오류 시 -> 모달 표시
			} else if (
				res.response &&
				res.response.status === 401 &&
				res.response.data.code === 'Too-Many-Login-Attempts'
			) {
				const minutes = res.response.data.message ? parseInt(res.response.data.message, 10) : 5;
				setRemainingMinutes(minutes);
				setShowTooManyAttemptsModal(true);
			} else {
				setShowFailModal(true);
			}
		} catch (err) {
			console.error(err);
			setShowFailModal(true);
		}
		// 승인 대기중인 상태도 있는듯? 아마 401 에러였던듯? 경로는 fail로 하면 해당 페이지 있음. 필요한 로직인가?
	}

	const handleKeyDown = event => {
		if (event.key.toLowerCase() === 'enter') {
			trySignIn();
		}
	};

	const SignInFailModalHeader = (
		<div className="signinModal__header">
			<p>로그인</p>
		</div>
	);

	const SignInFailModalBody = (
		<div className="signinModal__body">
			<p>{type === 'dtx006' ? '아이디와 비밀번호가 일치하지 않습니다.' : '회원이 아닙니다.'}</p>
			<button onClick={() => setShowFailModal(false)}>확인</button>
		</div>
	);

	const SignInEmptyModalHeader = (
		<div className="signinModal__header">
			<p>로그인</p>
		</div>
	);

	const SignInEmptyModalBody = (
		<div className="signinModal__body">
			<p>아이디와 비밀번호를 확인해주세요.</p>
			<button onClick={() => setShowEmptyModal(false)}>확인</button>
		</div>
	);

	const SignInTooManyAttemptsModalHeader = (
		<div className="signinModal__header">
			<p>로그인</p>
		</div>
	);

	const SignInTooManyAttemptsModalBody = (
		<div className="signinModal__body">
			<p>비밀번호 5회 오류로 로그인이 제한되었습니다.</p>
			<p>{remainingMinutes}분 뒤 다시 시도해 주세요.</p>
			<button onClick={() => setShowTooManyAttemptsModal(false)}>확인</button>
		</div>
	);

	const SignInSessionExpiredModalHeader = (
		<div className="signinModal__header">
			<p>로그인</p>
		</div>
	);

	const SignInSessionExpiredModalBody = (
		<div className="signinModal__body">
			<p>세션이 만료되었거나 다른 기기에서 로그인되어 로그아웃되었습니다. 다시 로그인해주세요.</p>
			<button onClick={() => setShowSessionExpiredModal(false)}>확인</button>
		</div>
	);

	const handleChangeSaveId = e => {
		if (e.target.checked) {
			localStorage.setItem('saveId', id);
		} else {
			localStorage.removeItem('saveId');
		}
		setSaveId(e.target.checked);
	};

	useEffect(() => {
		if (saveId) {
			localStorage.setItem('saveId', id);
		}
	}, [id]);

	// 세션 만료(토큰 갱신 실패)로 강제 로그아웃된 경우 안내
	useEffect(() => {
		if (sessionStorage.getItem(`${type}SessionExpired`)) {
			sessionStorage.removeItem(`${type}SessionExpired`);
			setShowSessionExpiredModal(true);
		}
	}, [type]);

	return (
		<div className="signinLayout">
			<div className="signinLayout__wrapper">
				<div className="signinLayout__wrapper__header">
					<span className="signinLayout__wrapper__header__title">로그인</span>
				</div>
				<hr className="signinLayout__wrapper__divider" style={{ marginBottom: '5rem' }} />
				<div className="signinLayout__wrapper__body">
					<div className="signinLayout__wrapper__body__option" style={{ marginBottom: '2rem' }}>
						<span className="optionItem__label">아이디</span>
						<div className="optionItem__content">
							<div className="optionItem__content__input">
								<input
									type="text"
									value={id}
									maxLength={20}
									onChange={e => {
										setId(e.target.value);
									}}
									onKeyDown={handleKeyDown}
									placeholder={type === 'dtx006' ? '아이디를 입력해주세요' : ''}
								/>
								{hasForbiddenChars(id) && (
									<p className="optionItem__content__input__validation non_valid">
										{FORBIDDEN_CHARS_MSG}
									</p>
								)}
							</div>
						</div>
					</div>
					<div className="signinLayout__wrapper__body__option" style={{ marginBottom: '1rem' }}>
						<span className="optionItem__label">비밀번호</span>
						<div className="optionItem__content">
							<div className="optionItem__content__input">
								<input
									type="password"
									value={pw}
									maxLength={20}
									onChange={e => {
										setPw(e.target.value);
									}}
									onKeyDown={handleKeyDown}
									placeholder={type === 'dtx006' ? '비밀번호를 입력해주세요' : ''}
								/>
								{hasForbiddenChars(pw) && (
									<p className="optionItem__content__input__validation non_valid">
										{FORBIDDEN_CHARS_MSG}
									</p>
								)}
							</div>
						</div>
					</div>
					<div className="signinLayout_wrapper__body__checkbox">
						<input id="save_id" type="checkbox" checked={!!saveId} onChange={handleChangeSaveId} />
						<label htmlFor="save_id">아이디 저장</label>
					</div>
					<div className="signinLayout__wrapper__body__footer">
						<button className="submitButton" onClick={trySignIn}>
							로그인
						</button>
					</div>
					<div className="signinLayout__wrapper_body_link_wrapper">
						<Link to={`/sign-up/${type}`}>회원가입</Link>
						<Link to={`/search-account/${type}`}>
							{type === 'dtx006' ? '아이디와 비밀번호를 잊어버렸다면?' : '아이디/비밀번호 찾기'}
						</Link>
					</div>
				</div>
				<hr className="signinLayout__wrapper__divider" style={{ marginBottom: '1.25rem' }} />

				{type === 'dtx006' ? (
					<div className="signinLayout__wrapper__app__info">
						(주)디지털팜
						<br />
						<br />
						대표자 : 김대진
						<br />
						<br />
						사업자등록번호 : 647-87-02394
						<br />
						<br />
						대표전화 : 02-533-0711
						<br />
						<br />
						주소 : 서울특별시 서초구 반포대로 222, 연구동 3층(반포동, 가톨릭대학교 성의교정
						옴니버스파크)
					</div>
				) : (
					''
				)}

				{type === 'dtx002' ? (
					<div className="signinLayout__wrapper__app__info">
						제조업사 상호 및 주소 :
						<br />
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(주)디지털팜
						<br />
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;서울특별시 서초구 반포대로 222 가톨릭대학교 성의교정
						옴니버스파크 연구동(B동) 3층 3201호, 3203호 (주)디지털팜
						<br />
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Tel: 02 533 0711
						<br />
						<br />
						허가번호 : -
						<br />
						<br />
						제품명 : {type === 'dtx001' ? '알코지니' : '히어路(HearRO)'}
						<br />
						<br />
						품목명/등급 : {type === 'dtx001' ? '인지치료소프트웨어/2등급' : '청력재활소프트웨어/2'}
						<br />
						<br />
						모델명 : {type === 'dtx001' ? 'DP-DTx-001' : 'DP-DTx-002'}
						<br />
						<br />
						소프트웨어 명칭 및 버전 :
						<br />
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;클라이언트 앱 V er 1.1
						<br />
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;API 서버 V er 1.1
						<br />
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;관리자 웹서버 V er 1.1
						<br />
						<br />
						제조연월 : -
						<br />
						<br />
						포장단위 : 1set
						<br />
						<br />
						의료기기 표준코드 (UDI) : (01)880CCCCPPPPPZ(10)v1.1
						<br />
						<br />본 제품은 “의료기기”임
						<br />
						의료기기 외의 목적으로 사용할 수 없음
					</div>
				) : (
					''
				)}
			</div>
			<CommonModal
				size="sm"
				header={SignInFailModalHeader}
				body={SignInFailModalBody}
				show={showFailModal}
				setClose={() => setShowFailModal(false)}
			/>
			<CommonModal
				size="sm"
				header={SignInEmptyModalHeader}
				body={SignInEmptyModalBody}
				show={showEmptyModal}
				setClose={() => setShowEmptyModal(false)}
			/>
			<CommonModal
				size="sm"
				header={SignInTooManyAttemptsModalHeader}
				body={SignInTooManyAttemptsModalBody}
				show={showTooManyAttemptsModal}
				setClose={() => setShowTooManyAttemptsModal(false)}
			/>
			<CommonModal
				size="sm"
				header={SignInSessionExpiredModalHeader}
				body={SignInSessionExpiredModalBody}
				show={showSessionExpiredModal}
				setClose={() => setShowSessionExpiredModal(false)}
			/>
		</div>
	);
}
export default SignInPage;
